package com.sweetlime.bingeamigo.model

import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.Serializable

@Serializable
data class LibraryMovie(
    val id: Int,
    val movie: Movie,
    val userRating: Double = 0.0,
    val userReview: String? = null,
    val watchlist: Boolean = false,
    val watched: Boolean = false,
    val favorite: Boolean = false,
    val addedAt: Timestamp? = null,
    val watchedAt: Timestamp? = null,
    val favoriteAt: Timestamp? = null
)

fun Movie.toLibraryMovie() = LibraryMovie(
    id = id,
    movie = this
)